import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/auth-context.jsx";
import { LoadingState } from "@/shared/ui/spinner.jsx";

/**
 * Proteção de rotas.
 *
 * No app antigo qualquer URL abria sem checagem — o "login" só escrevia no
 * `localStorage` e mandava o navegador para `/dashboard`. Aqui, entrar numa
 * rota protegida exige sessão válida confirmada pelo servidor.
 */

/** Exige sessão. Sem ela, manda para o login guardando o destino. */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingState message="Verificando sua sessão..." />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

/**
 * Exige um dos papéis informados. Quem não tem vai para a própria home,
 * em vez de ver uma tela em branco.
 * @param {{ roles: string[] }} props
 */
export function RequireRole({ roles }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LoadingState message="Verificando permissões..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={user.homeRoute} replace />;

  return <Outlet />;
}

/** Impede que quem já está logado veja a tela de login de novo. */
export function RedirectIfAuthenticated({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return <LoadingState message="Carregando..." />;
  if (isAuthenticated) return <Navigate to={user.homeRoute} replace />;

  return children;
}
